import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';
import { ApiHttpService } from 'src/app/core/services/api-http.service';

@Injectable({
  providedIn: 'root'
})
export class PontoService {

  isLocal = false;

  constructor(
    private apiEndpointsService: ApiEndpointsService,
    private apiHttpService: ApiHttpService,
    private http: HttpClient
  ) { }

  getPontoRedirectUrl(gpId: string, vehicleId: string) {
    return this.apiHttpService.get(
      this.apiEndpointsService.createUrl(
        `gps/${gpId}/vehicles/${vehicleId}/redirect-url`,
        this.isLocal
      ), {}
    );
  }

  getSyncStatus(vehicleId: string) {
    return this.apiHttpService.get(
      this.apiEndpointsService.createUrl(
        `vehicles/${vehicleId}/sync-status`,
        this.isLocal
      ), {}
    );
  }

  createInitialAccessToken(vehicleId: string, body: any) {
    return this.apiHttpService.post(
      this.apiEndpointsService.createUrl(
        `vehicles/${vehicleId}/create-initial-token`,
        this.isLocal
      ), body
    );
  }

  getBankAccounts(vehicleId: string) {
    return this.apiHttpService.get(
      this.apiEndpointsService.createUrl(
        `vehicles/${vehicleId}/accounts`,
        this.isLocal
      )
    );
  }

  deleteBankAccount(accountId: string, vehicleId: string) {
    return this.apiHttpService.delete(
      this.apiEndpointsService.createUrl(
        `vehicles/${vehicleId}/accounts/${accountId}`,
        this.isLocal
      )
    );
  }

  syncBankAccount(vehicleId: string, body: any) {
    return this.apiHttpService.post(
      this.apiEndpointsService.createUrl(
        `vehicles/${vehicleId}/synchronization`,
        this.isLocal
      ), body
    );
  }

  getClientIp() {
    return this.http.get('https://api.ipify.org?format=json', { responseType: 'json' });
  }
}
